import TransactionWrapper from '../../models/TransactionWrapper';
import * as React from 'react';
import StreamItem from '../live/StreamItem';
import { Loader } from '@symphony-ui/uitoolkit-components';
import { sendFetchError } from 'utils/messageUtils';
import MesssagesModal from '../transactions/overview/MessagesModal';
import DownloadContext from 'contexts/DownloadContext';
import ApiServerURL from 'models/ApiServerUrl';
import ApiServerRequest from 'models/ApiServerRequest';
const StreamPanel = ({ className = "", isVisible, ref }) => {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const [cmoError, setCmoError] = React.useState();
    const [cmoItems, setCmoItems] = React.useState([]);
    const [cmoLoading, setCmoLoading] = React.useState(false);
    const [detailsId, setDetailsId] = React.useState();
    React.useEffect(() => {
        const abortController = new AbortController();
        (async () => {
            const url = new ApiServerURL('/syndicate/transactions/page');
            url.searchParams.append('start', '0');
            url.searchParams.append('end', '100');
            const request = new ApiServerRequest(url);
            try {
                setCmoLoading(true);
                const body = await apiFetchJson(request, abortController.signal);
                const transactions2 = body.map((t) => new TransactionWrapper(t));
                setCmoItems(transactions2);
            }
            catch (error) {
                if (!(error instanceof Error && error.name === 'AbortError')) {
                    sendFetchError('Unable to download transactions', error, request);
                    setCmoError("Unable to download transactions");
                }
            }
            finally {
                setCmoLoading(false);
            }
        })();
        return () => abortController.abort();
    }, [apiFetchJson]);
    const showMessagesModal = React.useMemo(() => detailsId !== undefined, [detailsId]);
    return (React.createElement("div", { className: `${className}${isVisible ? ' co-visible' : ''}`, ref: ref },
        showMessagesModal ?
            React.createElement(MesssagesModal, { hideModal: () => setDetailsId(undefined), splitScreen: false, transactionId: detailsId }) : undefined,
        !cmoLoading && cmoError === undefined
            ? (React.createElement("div", { style: { height: '100%', overflowY: 'scroll' } }, cmoItems.map((m) => (React.createElement(StreamItem, { key: m.id, messages: m, setDetailsId: setDetailsId })))))
            : (React.createElement("div", { className: "loader-wrapper3" }, cmoLoading ? React.createElement(Loader, { className: "co-center-page", type: "spinner", variant: "primary" }) : React.createElement("p", null, cmoError)))));
};
export default StreamPanel;
